var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let MainContent = class MainContent extends LitElement {
    constructor() {
        super(...arguments);
        this.builds = [];
        this.last_err = "";
        this.auth = "";
        this.loading_list = false;
    }
    render() {
        return html `
			<h2>Builds</h2>
			<button @click=${this.refresh_build_list}>Refresh the list</button>
			${this.last_err ? html `<p class="error">${this.last_err}</p>` : nothing}
			<p>Builds that been uploaded:</p>
			${this.render_items()}
		`;
    }
    render_items() {
        if (this.loading_list) {
            return html `<p>Fetching em...</p>`;
        }
        return html `${this.builds.map(item => this.render_item(item))}`;
    }
    render_item(build) {
        return html `
			<div class="build">
				<h3>${build.name}</h3>
				<p>Last modified ${build.last_modify}</p>
				<p>
				${this.render_item_url(build)}
				</p>
				${build.error ? html `<p class="error">${build.error}</p>` : nothing}
			</div>
		`;
    }
    render_item_url(build) {
        if (build.fetching) {
            return html `Creating download link`;
        }
        return build.url
            ? html `<a href=${build.url}>Download (valid for 3 hours max)</a>`
            : html `<button @click=${() => this.get_url(build)}>Generate download link</button>`;
    }
    async get_url(build) {
        build.fetching = true;
        this.requestUpdate("builds");
        const url = await this.fetch_url(build.name);
        if (url) {
            build.url = url;
        }
        build.fetching = false;
        this.requestUpdate("builds");
    }
    async fetch_url(build_name) {
        build_name = build_name.replace("builds/", "");
        const request = await fetch(`https://api.95b0db3eec.net/signed-url?f=${build_name}`, {
            headers: {
                "Authorization": this.auth,
                "Content-Type": "application/json",
            }
        });
        const body = await request.json();
        if (request.status == 200) {
            return body.url;
        }
        else {
            console.log(`${request.status} ${body}`);
            return "";
        }
    }
    async refresh_build_list() {
        this.loading_list = true;
        const request = await fetch("https://api.95b0db3eec.net/list-builds", {
            headers: {
                "Authorization": this.auth,
                "Content-Type": "application/json",
            }
        });
        const body = await request.json();
        if (request.status == 200) {
            this.builds = body.filter(i => i.Size > 0).map(i => ({
                name: i.Key,
                last_modify: i.LastModified,
                fetching: false,
            }));
        }
        else {
            this.last_err = `${body}`;
        }
        this.loading_list = false;
    }
};
MainContent.styles = css `
		.build {
			margin: 1em;
			border: 2px dashed pink;
			padding-left: 1em;
			max-width: 600px;
		}

		.error {
			background-color: #111;
			color: tomato;
		}
	`;
__decorate([
    property({ type: Array })
], MainContent.prototype, "builds", void 0);
__decorate([
    property({ type: String })
], MainContent.prototype, "last_err", void 0);
__decorate([
    property({ type: String })
], MainContent.prototype, "auth", void 0);
__decorate([
    property({ type: Boolean })
], MainContent.prototype, "loading_list", void 0);
MainContent = __decorate([
    customElement('main-content')
], MainContent);
export { MainContent };
;
//# sourceMappingURL=main-content.js.map